import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidatorMessageModel } from '../../form-helpers/validation/validator-message.model';

@Component({
  selector: 'app-input-container',
  templateUrl: './input-container.component.html',
  styleUrls: ['./input-container.scss'],
})
export class InputContainerComponent implements OnInit {
  @Input() label?: string;
  @Input() for?: string;
  @Input() validationMessages?: ValidatorMessageModel[];
  @Input() biggerFont?: boolean;
  @Input() isRequired = false;

  @ViewChild('inputContainer') inputContainer?: ElementRef;
  hasValue = false;

  ngOnInit(): void {}

  public get isInvalid(): boolean {
    return this.validationMessages?.length! > 0;
  }

  public get isValid(): boolean {
    return !this.validationMessages || this.validationMessages.length === 0;
  }
}
